export enum UserStatus {
  'active',
  'inactive',
}
